import React, { useEffect, useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import './holerite.css';

const Holerite = () => {
    const [holerites, setHolerites] = useState([]);
    const [detalhesVisiveis, setDetalhesVisiveis] = useState({});
    const isMobile = window.innerWidth < 768;
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate()

    useEffect(() => {
        const chapa = localStorage.getItem("chapa");
        console.log('Validação: '+{chapa})
        if (!chapa) {
            navigate("/arbor/login"); // Redireciona se não for funcionário logado
        }
    }, []);

    useEffect(() => {
        const fetchHolerites = async () => {
            try {
                const res = await api.get(`/usuario/holerite/${chapa}`);
                setHolerites(res.data);
            } catch (err) {
                console.error('Erro ao buscar holerites:', err);
                Swal.fire('Erro', 'Não foi possível carregar os holerites.', 'error');
            }
        };

        fetchHolerites();
    }, [chapa]);

    const padMesAno = (mes, ano) => {
        return `${mes.toString().padStart(2, '0')}${ano}`;
    };

    const toggleDetalhes = async (index, periodo, mes, ano) => {
        const key = `${index}`;
        const visiveis = { ...detalhesVisiveis };

        if (visiveis[key]) {
            visiveis[key] = null;
        } else {
            try {
                const res = await api.get(`/usuario/holerite/${chapa}/selecionado?periodo=${periodo}&mesano=${padMesAno(mes, ano)}`);
                visiveis[key] = res.data;
            } catch (err) {
                console.error('Erro ao buscar detalhes do holerite:', err);
                Swal.fire('Erro', 'Erro ao carregar detalhes do holerite.', 'error');
                return;
            }
        }

        setDetalhesVisiveis(visiveis);
    };

    const aplicarMascaraCelular = (value) => {
        const numeros = value.replace(/\D/g, '').slice(0, 11); // apenas números, máx. 11 dígitos

        if (numeros.length <= 2) {
            return `(${numeros}`;
        } else if (numeros.length <= 7) {
            return `(${numeros.slice(0, 2)}) ${numeros.slice(2)}`;
        } else if (numeros.length <= 11) {
            return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 3)} ${numeros.slice(3, 7)}-${numeros.slice(7)}`;
        }
    };

    const limparMascaraCelular = (value) => {
        return value.replace(/\D/g, '');
    };

    const enviar = async (tipo, periodo, mes, ano, dados) => {
        const contatoPadrao = tipo === 'whatsapp'
            ? aplicarMascaraCelular(dados.telefone2 || '')
            : (dados.email || '');

        const { value: destino } = await Swal.fire({
            title: `Enviar via ${tipo === 'email' ? 'E-mail' : 'WhatsApp'}`,
            input: 'text',
            inputLabel: `Digite o ${tipo === 'email' ? 'e-mail' : 'número de WhatsApp'}:`,
            inputValue: contatoPadrao,
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
            didOpen: () => {
                if (tipo === 'whatsapp') {
                    const input = Swal.getInput();
                    input.addEventListener('input', () => {
                        input.value = aplicarMascaraCelular(input.value);
                    });
                }
            },
            inputValidator: (value) => {
                if (!value) {
                    return `Você precisa informar um ${tipo === 'email' ? 'e-mail' : 'número de WhatsApp'} válido!`;
                }
            }
        });

        if (destino) {
            const numeroFinal = tipo === 'whatsapp' ? limparMascaraCelular(destino) : destino;

            try {
                console.log(numeroFinal);
                await api.post(`/usuario/holerite/${chapa}`, {
                    tipo,
                    periodo,
                    mes,
                    ano,
                    destino: numeroFinal
                });
                Swal.fire('Enviado', `Holerite enviado por ${tipo === 'email' ? 'e-mail' : 'WhatsApp'} para ${destino}.`, 'success');
            } catch (err) {
                console.error('Erro ao enviar holerite:', err);
                Swal.fire('Erro', 'Erro ao enviar holerite.', 'error');
            }
        }
    };

    return (
        <div>
            <Menu modulo="ARBOR" />
            <div className="container-fluid mt-4">
                <h3>Meus Holerites</h3>

                {holerites.map((item, index) => (
                    <div key={index} className="card mb-2">
                        <div
                            className="card-header d-flex justify-content-between align-items-center"
                            onClick={() => toggleDetalhes(index, item.holf_periodo, item.holf_mes, item.holf_ano)}
                            style={{ cursor: 'pointer' }}
                        >
                            <span>
                                <strong className="info-holerite">
                                    {item.holf_mes.toString().padStart(2, '0')}/{item.holf_ano} - {item.desc_periodo}
                                </strong>
                            </span>
                            <span>
                                <strong className="info-data"> Liberado em: {item.holf_datahora}
                                </strong>
                            </span>
                            <span>
                                <strong className="holf_mensagem" style={{ fontStyle: 'italic', padding: '2px 6px', borderRadius: '4px' }}>{item.holf_mensagem}
                                </strong>
                            </span>
                            <span>{detalhesVisiveis[index] ? '▲' : '▼'}</span>
                        </div>

                        <div className={`collapse-wrapper ${detalhesVisiveis[index] ? 'open' : ''}`}>
                            {detalhesVisiveis[index] && (
                                <div className="card-body">
                                    <table className="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Evento</th>
                                                <th>Descrição</th>
                                                {!isMobile ? <th className="text-end">Referência</th> : <th className="text-end">Ref</th>}
                                                <th className="text-end">{isMobile ? 'Valores' : 'Provento'}</th>
                                                {!isMobile && <th className="text-end">Desconto</th>}
                                                {!isMobile && <th className="text-end">Base</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detalhesVisiveis[index].itens.map((linha, idx) => (
                                                <tr key={idx}>
                                                    <td className="text-center">{linha.cod}</td>
                                                    <td>{linha.descricao}</td>
                                                    <td className="text-end">{linha.ref}</td>
                                                    <td className="text-end">
                                                        {linha.valprovento && (
                                                            <span style={{ color: 'black' }}>{linha.valprovento}{isMobile && <span><i className="fa fa-plus-circle circle-blue" aria-hidden="true"></i></span>}</span>
                                                        )}
                                                        {linha.valdesconto && isMobile && (
                                                            <div style={{ color: 'red' }}>{linha.valdesconto}<i className="fa fa-minus-circle" aria-hidden="true"></i></div>
                                                        )}
                                                        {linha.valbase && isMobile && (
                                                            <div style={{ color: 'green' }}>{linha.valbase}<i className="fa fa-info-circle" aria-hidden="true"></i></div>
                                                        )}
                                                    </td>
                                                    {!isMobile && <td className="text-end" style={{ color: linha.valdesconto ? 'red' : undefined }}>{linha.valdesconto}</td>}
                                                    {!isMobile && <td className="text-end" style={{ color: linha.valbase ? 'green' : undefined }}>{linha.valbase}</td>}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="row text-center mb-3">
                                        {['salario', 'baseinss', 'basefgts', 'fgts', 'baseirrf', 'faixairrf', 'totvenc', 'totdesc', 'valliq'].map((campo, idx) => (
                                            <div key={idx} className="col">
                                                <small>{campo.replace('tot', 'Total ').replace('valliq', 'Líquido').replace('faixairrf', 'Faixa IRRF').replace('baseirrf', 'Base IRRF').replace('fgts', 'FGTS').replace('basefgts', 'Base FGTS').replace('baseinss', 'Base INSS').replace('salario', 'Salário Base')}</small>
                                                <div className={`form-control form-control-sm ${campo === 'faixairrf' || campo === 'totdesc' ? 'text-danger' : campo === 'salario' || campo === 'valliq' ? 'fw-bold' : ''}`}>{detalhesVisiveis[index][campo]}</div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="d-flex justify-content-end gap-2">
                                        <button className="btn btn-outline-success btn-sm" onClick={() => enviar('whatsapp', item.holf_periodo, item.holf_mes, item.holf_ano, detalhesVisiveis[index])}>
                                            <i className="bi bi-whatsapp"></i> Enviar WhatsApp
                                        </button>
                                        <button className="btn btn-outline-dark btn-sm" onClick={() => enviar('email', item.holf_periodo, item.holf_mes, item.holf_ano, detalhesVisiveis[index])}>
                                            <i className="bi bi-envelope"></i> Enviar e-mail
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <Footer className="footer navbar-fixed-bottom" />
        </div>
    );
};

export default Holerite;
